import React, { useEffect, useMemo, useRef, useState } from 'react'
import useCaptureDataAndGeneratePDFBrowserAPI from '../../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDFBrowserAPI';
import { enumUtil } from '../../../utils/Enum';
import { Modal } from "react-bootstrap";
import DropdownValueHandler from '../../shared/SuperSearch/DropdownValueHandler';
import { encounterStatus } from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/Constants';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { useSelector } from 'react-redux';
import Loader from '../../shared/Loader/Loader';
import SelectedPreviewDataV2SOAP from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/SOAP/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2GIRP from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/GIRPNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2BIRP from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/BIRPNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2DAP from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/DAPNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2DAPP from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/DAPPNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2Therapy from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/TherapyNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2Massage from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/MassageNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2Physical from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/PhysicalNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2Other from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/OtherNote/Components/SelectedPreviewDataV2';
import SelectedPreviewDataV2CustomNote from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/CustomNote/Components/SelectedPreviewDataV2';
import PrintOutSelectDataModal from './PrintOutSelectDataModal';
import { GeneralDropDowns } from '../../../actions/GeneralPatientActions';
import { useDispatch } from 'react-redux';
import FormatDate from '../../shared/DateFormatter';
import isNull from '../../../utils/NullChecking';


const PrintBulkEncounter = ({ isOpenBulkPrint:printoutSelectDataModal, setIsOpenBulkPrint:setPrintoutSelectDataModal, selectedEncounterIDs, ...props }) => {

    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    // Default selected items for each note type
    const DEFAULT_SELECTED_SOAP = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        vitals: true,
        problems: true,
        plan: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_GIRP = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        goalsNotes: true,
        interventionNotes: true,
        responseNotes: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_BIRP = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        behaviourNotes: true,
        interventionNotes: true,
        responseNotes: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_DAP = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        dataNotes: true,
        assessmentNotes: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_DAPP = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        dataNotes: true,
        assessmentNotes: true,
        progressNotes: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_THERAPY = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        objective: true,
        currentMentalStatus: true,
        intervention: true,
        interventionsUsed: true,
        response: true,
        responseObservations: true,
        assessment: true,
        riskAssessment: true,
        planNotes: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_MASSAGE = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        subjectiveNotes: true,
        objectiveNotes: true,
        assessmentNotes: true,
        planNotes: true,
        // currentMentalStatus: true,
        // intervention: true,
        // interventionsUsed: true,
        // response: true,
        // responseObservations: true,
        // assessment: true,
        // riskAssessment: true,
        // plan: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_PHYSICAL = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        problems: true,
        subjectiveNotes: true,
        objectiveNotes: true,
        assessment: true,
        planNotes: true,
        // currentMentalStatus: true,
        // intervention: true,
        // interventionsUsed: true,
        // response: true,
        // responseObservations: true,
        // assessment: true,
        // riskAssessment: true,
        // plan: true,
        uiDesign: false,
    };

    const DEFAULT_SELECTED_OTHER = {
        patientSummary: true,
        customTemplateClinical: false,
        chiefComplaint: true,
        vitals: true,
        problems: true,
        otherNote: true,
        uiDesign: false,
    };
const [showAddressTypeLocationSOAP, setShowAddressTypeLocationSOAP] = useState("false");
const [showAddressTypeLocationGIRP, setShowAddressTypeLocationGIRP] = useState("false");
const [showAddressTypeLocationBIRP, setShowAddressTypeLocationBIRP] = useState("false");
const [showAddressTypeLocationDAP, setShowAddressTypeLocationDAP] = useState("false");
const [showAddressTypeLocationDAPP, setShowAddressTypeLocationDAPP] = useState("false");
const [showAddressTypeLocationTherapy, setShowAddressTypeLocationTherapy] = useState("false");
const [showAddressTypeLocationMassage, setShowAddressTypeLocationMassage] = useState("false");
const [showAddressTypeLocationPhysical, setShowAddressTypeLocationPhysical] = useState("false");
const [showAddressTypeLocationOther, setShowAddressTypeLocationOther] = useState("false");
const [showAddressTypeLocationCustomNote, setShowAddressTypeLocationCustomNote] = useState({});
    // Initialize states for all notes
    const [selectedItemsSOAP, setSelectedItemsSOAP] = useState(DEFAULT_SELECTED_SOAP);
    const [selectedItemsGIRP, setSelectedItemsGIRP] = useState(DEFAULT_SELECTED_GIRP);
    const [selectedItemsBIRP, setSelectedItemsBIRP] = useState(DEFAULT_SELECTED_BIRP);
    const [selectedItemsDAP, setSelectedItemsDAP] = useState(DEFAULT_SELECTED_DAP);
    const [selectedItemsDAPP, setSelectedItemsDAPP] = useState(DEFAULT_SELECTED_DAPP);
    const [selectedItemsTherapy, setSelectedItemsTherapy] = useState(DEFAULT_SELECTED_THERAPY);
    const [selectedItemsMassage, setSelectedItemsMassage] = useState(DEFAULT_SELECTED_MASSAGE);
    const [selectedItemsPhysical, setSelectedItemsPhysical] = useState(DEFAULT_SELECTED_PHYSICAL);
    const [selectedItemsOther, setSelectedItemsOther] = useState(DEFAULT_SELECTED_OTHER);
    const [selectedItemsCustomNote, setSelectedItemsCustomNote] = useState({});
    const [selectedItemsUIView, setSelectedItemsUIView] = useState(false);
    const [printoutModal, setPrintoutModal] = useState(false);

    const selectedEncounters = 
     (props?.encounterMenuData?.length > 0 && selectedEncounterIDs?.length > 0 && typeof selectedEncounterIDs === 'string') ?
        (props?.encounterMenuData)
        .filter(enc => selectedEncounterIDs?.split(',')
        .map(id => id.trim()).includes(String(enc.EncounterID))) : [];
    let noteTypeSet = new Set(selectedEncounters?.flatMap(it => it.NoteType));
    let encounterID = 'many';
    return (
        <>
        {(printoutSelectDataModal && noteTypeSet?.size > 0) ?
          <PrintOutSelectDataModal 
            printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setPrintoutModal={setPrintoutModal} noteTypeSet={noteTypeSet}

            showAddressTypeLocationSOAP={showAddressTypeLocationSOAP}
            setShowAddressTypeLocationSOAP={setShowAddressTypeLocationSOAP}

            showAddressTypeLocationGIRP={showAddressTypeLocationGIRP}
            setShowAddressTypeLocationGIRP={setShowAddressTypeLocationGIRP}

            showAddressTypeLocationBIRP={showAddressTypeLocationBIRP}
            setShowAddressTypeLocationBIRP={setShowAddressTypeLocationBIRP}

            showAddressTypeLocationDAP={showAddressTypeLocationDAP}
            setShowAddressTypeLocationDAP={setShowAddressTypeLocationDAP}

            showAddressTypeLocationDAPP={showAddressTypeLocationDAPP}
            setShowAddressTypeLocationDAPP={setShowAddressTypeLocationDAPP}

            showAddressTypeLocationTherapy={showAddressTypeLocationTherapy}
            setShowAddressTypeLocationTherapy={setShowAddressTypeLocationTherapy}

            showAddressTypeLocationMassage={showAddressTypeLocationMassage}
            setShowAddressTypeLocationMassage={setShowAddressTypeLocationMassage}

            showAddressTypeLocationPhysical={showAddressTypeLocationPhysical}
            setShowAddressTypeLocationPhysical={setShowAddressTypeLocationPhysical}

            showAddressTypeLocationOther={showAddressTypeLocationOther}
            setShowAddressTypeLocationOther={setShowAddressTypeLocationOther}

            showAddressTypeLocationCustomNote={showAddressTypeLocationCustomNote}
            setShowAddressTypeLocationCustomNote={setShowAddressTypeLocationCustomNote}
            
            id = {encounterID}

            selectedItemsSOAP={selectedItemsSOAP} setSelectedItemsSOAP={setSelectedItemsSOAP}
            selectedItemsGIRP={selectedItemsGIRP} setSelectedItemsGIRP={setSelectedItemsGIRP} 
            selectedItemsBIRP={selectedItemsBIRP} setSelectedItemsBIRP={setSelectedItemsBIRP} 
            selectedItemsDAP={selectedItemsDAP} setSelectedItemsDAP={setSelectedItemsDAP} 
            selectedItemsDAPP={selectedItemsDAPP} setSelectedItemsDAPP={setSelectedItemsDAPP} 
            selectedItemsTherapy={selectedItemsTherapy} setSelectedItemsTherapy={setSelectedItemsTherapy} 
            selectedItemsMassage={selectedItemsMassage} setSelectedItemsMassage={setSelectedItemsMassage}
            selectedItemsPhysical={selectedItemsPhysical} setSelectedItemsPhysical={setSelectedItemsPhysical}
            selectedItemsOther={selectedItemsOther} setSelectedItemsOther={setSelectedItemsOther}
            selectedItemsCustomNote={selectedItemsCustomNote} setSelectedItemsCustomNote={setSelectedItemsCustomNote}
            selectedItemsUIView={selectedItemsUIView} setSelectedItemsUIView={setSelectedItemsUIView}/> : <></>}
          {printoutModal &&
            <SelectedPrintModal  

                showAddressTypeLocationSOAP={showAddressTypeLocationSOAP}
                showAddressTypeLocationGIRP={showAddressTypeLocationGIRP}
                showAddressTypeLocationBIRP={showAddressTypeLocationBIRP}
                showAddressTypeLocationDAP={showAddressTypeLocationDAP}
                showAddressTypeLocationDAPP={showAddressTypeLocationDAPP}
                showAddressTypeLocationTherapy={showAddressTypeLocationTherapy}
                showAddressTypeLocationMassage={showAddressTypeLocationMassage}
                showAddressTypeLocationPhysical={showAddressTypeLocationPhysical}
                showAddressTypeLocationOther={showAddressTypeLocationOther}
                showAddressTypeLocationCustomNote={showAddressTypeLocationCustomNote}

                selectedEncounterIDs={selectedEncounterIDs} 
                printoutSelectDataModal={printoutModal} setPrintoutSelectDataModal={setPrintoutModal} {...props} 
                selectedItemsSOAP={selectedItemsSOAP} selectedItemsGIRP={selectedItemsGIRP} selectedItemsBIRP={selectedItemsBIRP} selectedItemsDAP={selectedItemsDAP} selectedItemsDAPP={selectedItemsDAPP} selectedItemsTherapy={selectedItemsTherapy} selectedItemsMassage={selectedItemsMassage} selectedItemsPhysical={selectedItemsPhysical} selectedItemsOther={selectedItemsOther} selectedItemsCustomNote={selectedItemsCustomNote} selectedItemsUIView={selectedItemsUIView}/>}
        </>
    )
} 

export default PrintBulkEncounter

const SelectedPrintModal = ({ 
        selectedEncounterIDs, printoutSelectDataModal: printoutModal, setPrintoutSelectDataModal: setPrintoutModal,
        selectedItemsSOAP, selectedItemsGIRP, selectedItemsBIRP, selectedItemsDAP, selectedItemsDAPP, selectedItemsTherapy, selectedItemsMassage, selectedItemsPhysical, selectedItemsOther, selectedItemsCustomNote, selectedItemsUIView, ...props}) => {

    const { isLoading: isLoadingPdf, captureDataAndGeneratePDF } = useCaptureDataAndGeneratePDFBrowserAPI();
    const componentRef = useRef(null);
    const API_URL = enumUtil.controller.PatientEncounter;
    const selectedEncounters =  props?.encounterMenuData.filter(enc => selectedEncounterIDs?.split(',')
        .map(id => id.trim()).includes(String(enc.EncounterID)));
    
    console.log("selectedRows1234 SelectedPrintModal",props?.encounterMenuData, selectedEncounterIDs )
    let Data = selectedEncounters?.[0] || {};
    const [isLoading, setIsLoading] = useState(false);
    const [bulkEncountersData, setBulkEncountersData] = useState([]);

    const callAPI = (modal) => {
        let {  APILink, ...saveModal } = modal;
        return ServerRequestProtected( APILink, 'post', { ...saveModal });
    } 

    const fetchData = () => {
        setIsLoading(true);
        let fetchModalList = selectedEncounters.map(({ NoteType, EncounterID : ID, ...rest }) => {
            let TableName = 
                NoteType === 'SOAP' ? 
                    enumUtil.enumAPITableName.Encounter :
                NoteType === 'GIRP' ? 
                    enumUtil.enumAPITableName.GIRPNote :
                NoteType === 'BIRP' ? 
                    enumUtil.enumAPITableName.BIRPNote :
                NoteType === 'DAP' ? 
                    enumUtil.enumAPITableName.DAPNote :
                NoteType === 'DAPP' ? 
                    enumUtil.enumAPITableName.DAPPNote :
                NoteType === 'Therapy' ? 
                    enumUtil.enumAPITableName.TherapyNote :
                NoteType === 'Massage' ? 
                    enumUtil.enumAPITableName.MassageNote :
                NoteType === 'Physical' ? 
                    enumUtil.enumAPITableName.PhysicalNote :
                NoteType === 'Other' ? 
                    enumUtil.enumAPITableName.OtherNote : enumUtil.enumAPITableName.CustomNote ;

            let APILink = 
                NoteType === 'SOAP' ? 
                    API_URL + "/GetSOAPEncounter" :
                NoteType === 'GIRP' ? 
                    API_URL + "/GetGIRPNote" :
                NoteType === 'BIRP' ? 
                    API_URL + "/GetBIRPNote" :
                NoteType === 'DAP' ? 
                    API_URL + "/GetDAPNote" :
                NoteType === 'DAPP' ? 
                    API_URL + "/GetDAPPNote" :
                NoteType === 'Therapy' ? 
                    API_URL + "/GetTherapyNote" :
                NoteType === 'Massage' ? 
                    API_URL + "/GetMassageNote" :
                NoteType === 'Physical' ? 
                    API_URL + "/GetPhysicalNote" :
                NoteType === 'Other' ? 
                    API_URL + "/GetOtherNote" : API_URL + "/GetCustomNote";

            return ({ TableName, ID, APILink})
        })
        console.log("selectedEncounterIDs12345", fetchModalList)
        setBulkEncountersData([]);
        Promise.allSettled(fetchModalList.map(modal => callAPI(modal)))
            .then(results => {
                console.log("All API responses:", results);
                const successfulResults = results
                    .filter(r => r.status === 'fulfilled')
                    .map(r => r.value);

                // const failedResults = results
                //     .filter(r => r.status === 'rejected')
                //     .map(r => r.reason);

                console.log("APIAPI Successful:", successfulResults);
                // console.log("APIAPI Failed:", failedResults);

                setBulkEncountersData(successfulResults);
                // results is an array containing returned values of each callAPI()
                setIsLoading(false);
            })
            .catch(error => {
                console.error("One of the API calls failed:", error);
                setIsLoading(false); // still stop loading even if one fails
            });
    }

    useEffect(() => {
        fetchData();
    },[])

    let VITALS_DATA = [{
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Height",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Weight",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "BMI",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "BMI Percentile",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "BP",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Temperature",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Pulse",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Respiratory Rate",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "O2 Saturation",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Pain",
        VitalValue: ""
    }, {
        PatientID: Data?.PatientID,
        VitalID: "0",
        VitalName: "Head Circumference",
        VitalValue: ""
    }];
    let visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);

        return (
            <Modal show={printoutModal} onHide={printoutModal} backdrop="static" keyboard={false} centered dialogClassName="ar_encounter_print_modal ar_encounter_main_screen ar_encounter_preview_sceen p-0 hk-modal-v1 table-default-design bg-transparent" >
                {(isLoadingPdf || isLoading) && <Loader />}
                <Modal.Body className='hover-scrollbar'>
                    <div className="d-flex align-items-center justify-content-center gap-2 pt-15 ar_print-header pb-2">
                        <span class="icon-Group-1000002858 fs-20"
                        onClick={() => captureDataAndGeneratePDF(componentRef, `Bulk Encounters.pdf`, 'highRes')}
                        >
                            <span class="path1"></span><span class="path2"></span>
                        </span>
                        <i className="icon-Icon-metro-cross fs-20" onClick={() => setPrintoutModal(false)}></i>
                    </div>
                    <div ref={componentRef} className='ar-bulk-pdf-print'>
                        {/* {Number(props?.encounterMenuData?.length) - Number(bulkEncountersData?.length)} */}
                        {bulkEncountersData.map(initialData => (
                            <div className={`px-10 pb-15 pt-2 ar_native_pdf_design encounter-notes-design ${selectedItemsUIView ? 'Black-in-White-Design' : ''}`}>
                            {initialData?.Data?.NoteType === 'SOAP'?
                                <SOAPView  initialData={initialData} VITALS_DATA={VITALS_DATA} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsSOAP} showAddressTypeLocation={props?.showAddressTypeLocationSOAP}/>: 
                            initialData?.Data?.NoteType === 'GIRP'?
                                <GIRPView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsGIRP} showAddressTypeLocation={props?.showAddressTypeLocationGIRP}/> :
                            initialData?.Data?.NoteType === 'BIRP'?
                                <BIRPView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsBIRP} showAddressTypeLocation={props?.showAddressTypeLocationBIRP}/> :
                            initialData?.Data?.NoteType === 'DAP'?
                                <DAPView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsDAP} showAddressTypeLocation={props?.showAddressTypeLocationDAP}/> :
                            initialData?.Data?.NoteType === 'DAPP'?
                                <DAPPView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsDAPP} showAddressTypeLocation={props?.showAddressTypeLocationDAPP}/> :
                            initialData?.Data?.NoteType === 'Therapy'?
                                <TherapyView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsTherapy} showAddressTypeLocation={props?.showAddressTypeLocationTherapy}/> :
                            initialData?.Data?.NoteType === 'Massage'?
                                <MassageView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsMassage} showAddressTypeLocation={props?.showAddressTypeLocationMassage}/> :
                            initialData?.Data?.NoteType === 'Physical'?
                                <PhysicalView  initialData={initialData} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsPhysical} showAddressTypeLocation={props?.showAddressTypeLocationPhysical}/> :
                            initialData?.Data?.NoteType === 'Other' ? 
                            <OtherView  initialData={initialData} VITALS_DATA={VITALS_DATA} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsOther} showAddressTypeLocation={props?.showAddressTypeLocationOther}/> : 
                            <CustomNoteView  initialData={initialData} VITALS_DATA={VITALS_DATA} visitTypes={visitTypes} providerDD={providerDD} locationDD={locationDD} selectedItems={selectedItemsCustomNote?.[initialData?.Data?.NoteType]} showAddressTypeLocation={props?.showAddressTypeLocationCustomNote?.[initialData?.Data?.NoteType]}/>}
                            </div>
                        ))}
                    </div>
                    {/* </div> */}
                </Modal.Body>
            </Modal>
        )
}
const SOAPView = ({ initialData, VITALS_DATA, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);

    return  (<SelectedPreviewDataV2SOAP 
                selectedItems={selectedItems} data={initialData} showAddressTypeLocation={showAddressTypeLocation}
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "SubjectiveNotes": initialData?.Data?.SubjectiveNotes || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",
                        "Vital": initialData?.Vital || [],
                    } || {}),
                    ...({
                        "CognitiveStatus": initialData?.CognitiveStatus || [],
                        "FunctionalStatus": initialData?.FunctionalStatus || [],
                    } || {}),
                    ...({
                        "AssesmentNotes": initialData?.Data?.AssesmentNotes || "",
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                        "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                        "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                        "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                        "LabsNotes": initialData?.Data?.LabsNotes || "",
                        "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                        "PlanNotes": initialData?.Data?.PlanNotes || "",
                        "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                        "Vital": initialData?.Vital || [],
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "vitalData": VITALS_DATA,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}
const GIRPView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2GIRP 
                selectedItems={selectedItems} data={initialData} showAddressTypeLocation={showAddressTypeLocation}
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "GoalsNotes": initialData?.Data?.GoalsNotes || "",
                    } || {}),
                    ...({
                        "ResponseNotes": initialData?.Data?.ResponseNotes || "",
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                        "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                        "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                        "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                        "LabsNotes": initialData?.Data?.LabsNotes || "",
                        "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                        "PlanNotes": initialData?.Data?.PlanNotes || "",
                        "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "GoalsNotes": initialData?.Data?.GoalsNotes,
                "InterventionNotes": initialData?.Data?.InterventionNotes,
                "ResponseNotes": initialData?.Data?.ResponseNotes,
                "PlanNotes": initialData?.Data?.PlanNotes,
                "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}
const BIRPView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2BIRP 
                selectedItems={selectedItems} data={initialData} 
                showAddressTypeLocation={showAddressTypeLocation}
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "BehaviourNotes": initialData?.Data?.BehaviourNotes || "",
                    } || {}),
                    ...({
                        "ResponseNotes": initialData?.Data?.ResponseNotes || "",
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                        "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                        "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                        "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                        "LabsNotes": initialData?.Data?.LabsNotes || "",
                        "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                        "PlanNotes": initialData?.Data?.PlanNotes || "",
                        "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "BehaviourNotes": initialData?.Data?.BehaviourNotes,
                "InterventionNotes": initialData?.Data?.InterventionNotes,
                "ResponseNotes": initialData?.Data?.ResponseNotes,
                "PlanNotes": initialData?.Data?.PlanNotes,
                "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}

const DAPView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2DAP showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "DataNotes": initialData?.Data?.DataNotes,
                "AssesmentNotes": initialData?.Data?.AssesmentNotes,
                "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                "LabsNotes": initialData?.Data?.LabsNotes || "",
                "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                "PlanNotes": initialData?.Data?.PlanNotes || "",
                "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}
const DAPPView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2DAPP showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "DataNotes": initialData?.Data?.DataNotes,
                "AssesmentNotes": initialData?.Data?.AssesmentNotes,
                "ProgressNotes": initialData?.Data?.ProgressNotes,
                "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                "LabsNotes": initialData?.Data?.LabsNotes || "",
                "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                "PlanNotes": initialData?.Data?.PlanNotes || "",
                "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}

const TherapyView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const API_URL_PATIENT_ENCOUNTER = enumUtil.controller.PatientEncounter;
    let dispatch = useDispatch();
    /// TherapyNote ///
    const [cmsDDData, setCMSDDData] = useState({});
    useEffect(() => {
        if(!initialData?.Data?.PatientID) return;
        // Current Mental Status Dropdown //
        if (!DropDowns?.TherapyNote || Object.keys(DropDowns.TherapyNote).length === 0) {
            ServerRequestProtected(API_URL_PATIENT_ENCOUNTER + "/EncounterDropDown", 'post', {
                "TableName": enumUtil.enumAPITableName.EncounterDropDown,
                "ID": initialData?.Data?.PatientID,
            })
            .then((response) => {
                dispatch(GeneralDropDowns({ ...DropDowns, TherapyNote: response}));
                setCMSDDData(response)
            }).catch((error) => {
            })
        } else {
            setCMSDDData(DropDowns?.TherapyNote)
        }
            
    }, [initialData?.Data?.PatientID])

    let currentMentalStatusData = useMemo(() => {
        const { TableNameCMS, ...cmsData } = initialData?.CurrentMentalStatus || {};
        return Object.keys(cmsData).reduce((acc, key) => {
            acc[key] = DropdownValueHandler(cmsDDData[key], cmsData[key]) ?? "";
            return acc;
        }, {});
    }, [initialData?.CurrentMentalStatus, cmsDDData]);

    return  (<SelectedPreviewDataV2Therapy showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                searchValueCMS={currentMentalStatusData}
                Data={{
                "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                "EncounterProblem": initialData?.EncounterProblem || [],
                "CurrentMentalStatus": initialData?.CurrentMentalStatus || {},
                "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",
                "InterventionNotes": initialData?.Data?.InterventionNotes || "",
                "InterventionsUsedData": initialData?.InterventionsUsed || {},
                "ResponseNotes": initialData?.Data?.ResponseNotes || "",
                "ResponseObservations": initialData?.ResponseObservations || {},
                "RiskAssessment": initialData?.RiskAssessment || [],
                "AssesmentNotes": initialData?.Data?.AssesmentNotes || "",
                "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
                "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
                "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
                "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
                "LabsNotes": initialData?.Data?.LabsNotes || "",
                "ImagingNotes": initialData?.Data?.ImagingNotes || "",
                "PlanNotes": initialData?.Data?.PlanNotes || "",
                "FollowUpDate":  !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                "EncounterDocument": initialData?.EncounterDocument || [],
                "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}

const MassageView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    // const API_URL_PATIENT_ENCOUNTER = enumUtil.controller.PatientEncounter;
    // let dispatch = useDispatch();
    /// TherapyNote ///
    // const [cmsDDData, setCMSDDData] = useState({});
    // useEffect(() => {
    //     if(!initialData?.Data?.PatientID) return;
    //     // Current Mental Status Dropdown //
    //     if (!DropDowns?.TherapyNote || Object.keys(DropDowns.TherapyNote).length === 0) {
    //         ServerRequestProtected(API_URL_PATIENT_ENCOUNTER + "/EncounterDropDown", 'post', {
    //             "TableName": enumUtil.enumAPITableName.EncounterDropDown,
    //             "ID": initialData?.Data?.PatientID,
    //         })
    //         .then((response) => {
    //             dispatch(GeneralDropDowns({ ...DropDowns, TherapyNote: response}));
    //             setCMSDDData(response)
    //         }).catch((error) => {
    //         })
    //     } else {
    //         setCMSDDData(DropDowns?.TherapyNote)
    //     }
            
    // }, [initialData?.Data?.PatientID])

    // let currentMentalStatusData = useMemo(() => {
    //     const { TableNameCMS, ...cmsData } = initialData?.CurrentMentalStatus || {};
    //     return Object.keys(cmsData).reduce((acc, key) => {
    //         acc[key] = DropdownValueHandler(cmsDDData[key], cmsData[key]) ?? "";
    //         return acc;
    //     }, {});
    // }, [initialData?.CurrentMentalStatus, cmsDDData]);

    return  (<SelectedPreviewDataV2Massage showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                // searchValueCMS={currentMentalStatusData}
                Data={{
                    "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                    "SubjectiveNotes": initialData?.Data?.SubjectiveNotes || "",
                    "ObjectiveFinding": initialData?.ObjectiveFinding || {},
                    "RangeOfMotion": initialData?.RangeOfMotion || {},
                    "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",
                    "AssessmentAreaTreated": initialData?.AssessmentAreaTreated || {},
                    "AssessmentMethodUsed": initialData?.AssessmentMethodUsed || {},
                    "AssesmentNotes": initialData?.Data?.AssesmentNotes || "",
                    "EncounterProblem": initialData?.EncounterProblem || [],
                    "PlanNotes": initialData?.Data?.PlanNotes || "",
                    "HomeExerciseProgram": initialData?.Data?.HomeExerciseProgram || "",
                    "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                    "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    "EncounterDocument": initialData?.EncounterDocument || [],
                    "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                    "mainServiceLineModal": initialData?.SuperBill,
                    "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}

const PhysicalView = ({ initialData, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2Physical showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }}
                Data={{
                    "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                    "SubjectiveNotes": initialData?.Data?.SubjectiveNotes || "",

                    "ObservationNotes": initialData?.Data?.ObservationNotes || "",
                    "FrontBodyDiagram": initialData?.FrontBodyDiagram || [],
                    "BackBodyDiagram": initialData?.BackBodyDiagram || [],
                    "PalpationNotes": initialData?.Data?.PalpationNotes || "",
                    "RangeOfMotion": initialData?.RangeOfMotion || {},
                    "Strength": initialData?.Strength || {},
                    "TestMeasurementNotes": initialData?.Data?.TestMeasurementNotes || "",
                    "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",

                    // "AssessmentAreaTreated": initialData?.AssessmentAreaTreated || {},
                    // "AssessmentMethodUsed": initialData?.AssessmentMethodUsed || {},
                    "AssesmentNotes": initialData?.Data?.AssesmentNotes || "",
                    "EncounterProblem": initialData?.EncounterProblem || [],

                    "PlanNotes": initialData?.Data?.PlanNotes || "",
                    "TestMeasurementNotes": initialData?.Data?.TestMeasurementNotes || "",
                    "HomeExerciseProgram": initialData?.Data?.HomeExerciseProgram || "",
                    "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                    "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    "EncounterDocument": initialData?.EncounterDocument || [],
                    "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                    "mainServiceLineModal": initialData?.SuperBill,
                    "CustomTemplateData": initialData?.CustomTemplate || [],
                    "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
}

const OtherView = ({ initialData, VITALS_DATA, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2Other showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "Vital": initialData?.Vital || [],
                    } || {}),
                    ...({
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "OtherNote": initialData?.Data?.OtherNote || "",
                        "Vital": initialData?.Vital || [],
                        "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "vitalData": VITALS_DATA,
                "mainServiceLineModal": initialData?.SuperBill,
                "CustomTemplateData": initialData?.CustomTemplate || [],
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                }} 
            />)
} 

const CustomNoteView = ({ initialData, VITALS_DATA, visitTypes, providerDD, locationDD, selectedItems, showAddressTypeLocation }) => {
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    return  (<SelectedPreviewDataV2CustomNote showAddressTypeLocation={showAddressTypeLocation}
                selectedItems={selectedItems} data={initialData} 
                searchParam={{
                    // ...prev,
                    "EncounterType": initialData?.Data?.EncounterType,
                    "NoteType": initialData?.Data?.NoteType,
                    "EncounterDate": initialData?.Data?.EncounterDate,
                    "SeenBy": initialData?.Data?.SeenBy,
                    "Facility": initialData?.Data?.Facility,
                    "EncounterStatus": initialData?.Data?.EncounterStatus,
                    "VitalUnitType": initialData?.Data?.VitalUnitType || "US Customary",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID,
                }} 
                searchValue={{
                    // ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, initialData?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, initialData?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, initialData?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, initialData?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, initialData?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": initialData?.Data?.PatientAppointmentID ? initialData?.Data?.EncounterDate : "",
                }} 
                Data={{
                    ...({
                        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
                        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
                        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
                        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
                        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
                    } || {}),
                    ...({
                        "Vital": initialData?.Vital || [],
                    } || {}),
                    ...({
                        "EncounterProblem": initialData?.EncounterProblem || [],
                    } || {}),
                    ...({
                        "Vital": initialData?.Vital || [],
                        "CustomTemplateData": initialData?.CustomTemplate || [],
                        "MainCustomTemplateData": initialData?.MainCustomTemplate || [],
                        "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
                        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
                    } || {}),
                    ...({
                        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
                        "EncounterDocument": initialData?.EncounterDocument || [],
                    } || {}),
                "vitalData": VITALS_DATA,
                "mainServiceLineModal": initialData?.SuperBill,
                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                "isOpenedFromBulkPrint": "true"
                }} 
            />)
} 